// src/modules/estimates/AreaMeasurementModal.js
import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../../components/shared/Modal';
import Input from '../../components/shared/Input';
import Button from '../../components/shared/Button';
import { FaTrash } from 'react-icons/fa';
import { getUnitInfo } from './ServiceModal';

const AreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(2)};
  margin-bottom: ${(props) => props.theme.spacing(2)};

  .header{
    display: flex;
    justify-content: space-between;
    margin: 10px 0px;
  }
`;

const ActionIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: ${(props) => props.theme.spacing(2)};
  svg {
    cursor: pointer;
    &:hover {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

const AreaMeasurementModal = ({ isOpen, onClose, onSave, existingMeasurements = [], measurementUnit = 'sqft' }) => {
  const [areas, setAreas] = useState(existingMeasurements);
  const [newArea, setNewArea] = useState({
    name: '',
    width: '',
    length: '',
    totalArea: '',
  });

  const unitInfo = getUnitInfo(measurementUnit);
  const showWidthLength = measurementUnit === 'sqft';

  const handleAreaFieldChange = (field, value) => {
    const updatedArea = { ...newArea, [field]: value };
    if (showWidthLength && (field === 'width' || field === 'length')) {
      updatedArea.totalArea = parseFloat(updatedArea.width) * parseFloat(updatedArea.length);
    }
    if (!showWidthLength && field === 'totalArea') {
      updatedArea.totalArea = parseFloat(value) || 0;
    }
    setNewArea(updatedArea);
  };

  const handleAddArea = () => {
    setAreas([...areas, newArea]);
    setNewArea({ name: '', width: '', length: '', totalArea: '' });
  };

  const handleDeleteArea = (index) => {
    setAreas(areas.filter((_, i) => i !== index));
  };

  const handleSaveAreas = () => {
    onSave(areas);
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <Modal title="Measure Area" onConfirm={handleSaveAreas} onCancel={onClose} isOpen={isOpen} zIndex={1200}>
      <AreaWrapper>
        <Input
          label="Area Name"
          value={newArea.name}
          onChange={(e) => handleAreaFieldChange('name', e.target.value)}
        />
        {showWidthLength ? (
          <>
            <Input
              label="Width (ft)"
              type="number"
              value={newArea.width}
              onChange={(e) => handleAreaFieldChange('width', e.target.value)}
            />
            <Input
              label="Length (ft)"
              type="number"
              value={newArea.length}
              onChange={(e) => handleAreaFieldChange('length', e.target.value)}
            />
            <Input
              label={`Total Area (${unitInfo.short})`}
              type="number"
              value={newArea.totalArea}
              readOnly
            />
          </>
        ) : (
          <Input
            label={`Quantity (${unitInfo.short})`}
            type="number"
            value={newArea.totalArea}
            onChange={(e) => handleAreaFieldChange('totalArea', e.target.value)}
          />
        )}
        <Button type="button" onClick={handleAddArea}>
          Add Area
        </Button>
        {areas.map((area, index) => (
          <div className="header" key={index}>
            <span className='serviceName'>{area.name} - {area.totalArea} {unitInfo.short}</span>
                <ActionIcons>
                      <FaTrash onClick={() => handleDeleteArea(index)} />
                  </ActionIcons>
          </div>
        ))}
      </AreaWrapper>
    </Modal>
  );
};

export default AreaMeasurementModal;
